import { render, staticRenderFns } from "./ProductTips.vue?vue&type=template&id=4d0d1e02&scoped=true&"
import script from "./ProductTips.vue?vue&type=script&lang=ts&"
export * from "./ProductTips.vue?vue&type=script&lang=ts&"
import style0 from "./ProductTips.vue?vue&type=style&index=0&id=4d0d1e02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0d1e02",
  null
  
)

export default component.exports